export const ActionSetLoading = ({ commit }, payload) => {
  commit('SET_loading', payload)
}
